import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService, NcsLibModule } from '@ncs/ncs-lib';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-asset-report',
  templateUrl: './asset-report.component.html',
  styleUrls: ['./asset-report.component.scss'],
})
export class AssetReportComponent extends BaseListCtl {
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private http: HttpClient
  ) {
    super('', locator, route);
  }

  report: any = []; // Current page data
  filters: any = {
    plantCode: '',
    scanStatus: 'Scanned',
    startDate: new Date().toISOString().slice(0, 10),
    endDate: '',
  };

  // Column search inputs
  colSearch = {
    assetNumber: '',
    AssetDescription:'',
    assetLocation: '',
    assetCurrentLocation: '',
    scanType: '',
    scanned_value:'',
    status: '',
    userName: '',
    readerId: '',
    lastScan: ''
  };

  // Pagination
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 0;
  totalPages: number = 0;
  pageSizeOptions: number[] = [10, 25, 50, 100];
  
  // Sorting
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  selectedOrderBy: string = 'default';
  
  // Search timeout for debouncing
  searchTimeout: any;
  isSearching: boolean = false;

  // Fix: Add loading indicator
  isLoading: boolean = false;

  override ngOnInit(): void {
    // Optionally load default report on init
    // this.loadReport();
  }

  // Order by properties
  orderByOptions: { key: string; label: string }[] = [
    { key: 'default', label: '-- Order by --' },
    { key: 'assetNumber', label: 'Asset Number' },
    { key: 'assetLocation', label: 'Asset Location' },
    { key: 'lastScan', label: 'Last Scan' },
    { key: 'status', label: 'Status' }
  ];

  // Change order by method
  changeOrderBy(newOrder: string): void {
    this.selectedOrderBy = newOrder;
    if (newOrder !== 'default') {    
      this.sortData(newOrder); 
    }
  }

  // Main load report method
  loadReport(page: number = 1) {
    var _self = this;
    this.isLoading = true;
    
    // Validate required fields
    if (!this.filters['plantCode'] || !this.filters['startDate']) {
      console.warn('Plant Code and Start Date are required');
      this.isLoading = false;
      return;
    }

    const payload = {
      plantCode: this.filters.plantCode,
      scanStatus: this.filters.scanStatus,
      startDate: this.filters.startDate,
      endDate: this.filters.endDate,
      // Add search parameters to payload (for backend filtering)
      searchAssetNumber: this.colSearch.assetNumber,
      searchAssetDescription : this.colSearch.AssetDescription,
      searchAssetLocation: this.colSearch.assetLocation,
      searchCurrentLocation: this.colSearch.assetCurrentLocation,
      searchScanType: this.colSearch.scanType,
      searchScannValue:this.colSearch.scanned_value,
      searchStatus: this.colSearch.status,
      searchUserName: this.colSearch.userName,
      searchReaderId: this.colSearch.readerId,
      searchLastScan: this.colSearch.lastScan
    };

    this.locator.config
      .getProperty('endpoint.asset')
      .then((property: string) => {
        let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
        let sid = localStorage.getItem(keySuffix + 'sessionId');
        if (!sid) {
          sid = '0';
        }

        // Construct URL with query parameters
        const url = `${property}/assetReportPageination;jsessionid=${sid}?page=${page - 1}&size=${this.itemsPerPage}`;
        
        console.log('Making request to:', url);
        console.log('Payload:', payload);

        // Make HTTP POST request
        this.http.post(url, payload).subscribe({
          next: (res: any) => {
            this.isLoading = false;
            if (res && res.success) {
              const result = res.result;
              this.report = result.reportData || [];
              this.totalItems = result.total || 0;
              this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
              this.currentPage = page;
              
              console.log(`Loaded page ${page} with ${this.report.length} items`);
              console.log(`Total items: ${this.totalItems}, Total pages: ${this.totalPages}`);
              
              // If there's a sort order selected, apply it
              if (this.selectedOrderBy !== 'default') {
                this.sortData(this.selectedOrderBy);
              }
            } else {
              this.report = [];
              this.totalItems = 0;
              this.totalPages = 0;
              console.warn('API returned error or no data');
            }
          },
          error: (error) => {
            this.isLoading = false;
            console.error('Error fetching report', error);
            this.report = [];
            this.totalItems = 0;
            this.totalPages = 0;
          }
        });
      })
      .catch((err: any) => {
        this.isLoading = false;
        console.error('Error fetching API property', err);
        this.report = [];
        this.totalItems = 0;
        this.totalPages = 0;
      });
  }

  // Debounced search function
  applyFilters() {
    // Clear any existing timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    
    // Set a timeout to delay the search
    this.searchTimeout = setTimeout(() => {
      // Reset to first page when searching
      this.currentPage = 1;
      this.loadReport(1);
    }, 500); // Wait 500ms after user stops typing
  }

  // Clear all column searches
  clearColumnSearches() {
    this.colSearch = {
      assetNumber: '',
      AssetDescription:'',
      assetLocation: '',
      assetCurrentLocation: '',
      scanType: '',
      scanned_value:'',
      status: '',
      userName: '',
      readerId: '',
      lastScan: ''
    };
    this.currentPage = 1;
    this.loadReport(1);
  }

  // Pagination methods
  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.loadReport(page);
    } else {
      console.warn(`Invalid page number: ${page}. Valid range: 1-${this.totalPages}`);
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.loadReport(this.currentPage - 1);
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.loadReport(this.currentPage + 1);
    }
  }

  changePageSize(size: number) {
    this.itemsPerPage = size;
    this.currentPage = 1; // Reset to first page when changing size
    this.loadReport(this.currentPage);
  }

  // Sorting method
  sortData(column: string) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    
    // Sort the current page data (client-side)
    this.report.sort((a: any, b: any) => {
      let valueA = a[column];
      let valueB = b[column];

      // Handle null/undefined values
      if (valueA == null) valueA = '';
      if (valueB == null) valueB = '';

      // Convert to string for comparison
      const strA = String(valueA).toLowerCase();
      const strB = String(valueB).toLowerCase();

      if (this.sortDirection === 'asc') {
        return strA.localeCompare(strB);
      } else {
        return strB.localeCompare(strA);
      }
    });
  }

  // Generate array for select options
  getPageOptions(): number[] {
    return Array.from({length: this.totalPages}, (_, i) => i + 1);
  }

  getDisplayRange(): string {
    if (this.report.length === 0 || this.totalItems === 0) return '0-0 of 0';

    const start = (this.currentPage - 1) * this.itemsPerPage + 1;
    const end = Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
    return `${start}-${end} of ${this.totalItems}`;
  }

  // Reset all filters
  resetFilters() {
    this.filters = {
      plantCode: '',
      scanStatus: '',
      startDate: '',
      endDate: ''
    };
    this.currentPage = 1;
    this.itemsPerPage = 10;
    this.selectedOrderBy = 'default';
    this.report = [];
    this.totalItems = 0;
    this.totalPages = 0;
    this.clearColumnSearches();
  }

  /**
   * Export data in PDF
   */
  public downloadPdf() {
    let _self = this;
    const payload = {
      plantCode: this.filters.plantCode,
      scanStatus: this.filters.scanStatus,
      startDate: this.filters.startDate,
      endDate: this.filters.endDate,
    };

    this.locator.config
      .getProperty('endpoint.asset')
      .then((property: string) => {
        let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
        let sid = localStorage.getItem(keySuffix + 'sessionId');
        if (!sid) {
          sid = '0';
        }
        let url = property + '/assetReport' + '/pdf' + ';jsessionid=' + sid;

        _self.locator.http
          .getClient()
          .post(url, payload, { responseType: 'blob' })
          .subscribe(
            (data: any) => {
              _self.downloadDataAsFile(data, 'export.pdf');
            },
            (data: any) => {
              console.error(data);
            }
          );
      });
  }
  
  /**
   * Export data in PDF
   */
  public summaryReport() {
    let _self = this;
    const payload = {
      currentPlantLocation: this.filters.plantCode,
      startDate: this.filters.startDate,
      endDate: this.filters.endDate,
    };

    this.locator.config
      .getProperty('endpoint.asset')
      .then((property: string) => {
        let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
        let sid = localStorage.getItem(keySuffix + 'sessionId');
        if (!sid) {
          sid = '0';
        }
        let url = property + '/assetSummaryReportPDF' + ';jsessionid=' + sid;

        _self.locator.http
          .getClient()
          .post(url, payload, { responseType: 'blob' })
          .subscribe(
            (data: any) => {
              _self.downloadDataAsFile(data, 'export.pdf');
            },
            (data: any) => {
              console.error(data);
            }
          );
      });
  }
  
  /**
   * Export Sample data in CSV
   */
  public downloadCsv() {
    let _self = this;
    const payload = {
      plantCode: this.filters.plantCode,
      scanStatus: this.filters.scanStatus,
      startDate: this.filters.startDate,
      endDate: this.filters.endDate,
    };

    this.locator.config
      .getProperty('endpoint.asset')
      .then((property: string) => {
        let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
        let sid = localStorage.getItem(keySuffix + 'sessionId');
        if (!sid) {
          sid = '0';
        }
        let url = property + '/assetReport' + '/csv' + ';jsessionid=' + sid;

        _self.locator.http
          .getClient()
          .post(url, payload, { responseType: 'blob' })
          .subscribe(
            (data: any) => {
              _self.downloadDataAsFile(data, 'export.csv');
            },
            (data: any) => {
              console.error(data);
            }
          );
      });
  }
  
  /**
   * Download data as file
   * @param data
   * @param fileName
   */
  public downloadDataAsFile(data: any, fileName: string) {
    //Create a dynamic link and download file
    let file = new window.Blob([data], { type: data.type });
    const downloadAncher = document.createElement('a');
    downloadAncher.style.display = 'none';
    const fileURL = URL.createObjectURL(file);
    downloadAncher.href = fileURL;
    downloadAncher.download = fileName;
    downloadAncher.click();
  }
}